import $ from 'jquery';
import moment from 'moment';
import range from 'lodash.range';
import 'jquery-validation';
import 'easy-autocomplete';
import templates from './js/components-templates';
import './js/jqueryvalidation-plugins';
import './js/foundation-build';
import dict from './i18n/dictionary';

/* eslint-disable */
import 'font-awesome/css/font-awesome.min.css';
import './scss/foundation-build.scss';
import 'easy-autocomplete/dist/easy-autocomplete.min.css';
import './scss/Run.scss';
/* eslint-enable */

import './img/thumb.jpg';

window.$ = $;
let configLanguage = document.getElementById('Config_Language').value;
let changedName = 0;
let changedSurname = 0;
const googleApi = $.getScript(`https://maps.googleapis.com/maps/api/js?key=AIzaSyALF6wBg7ka7L1vlCMHuS-QyNS6Kj2BgP8&libraries=places&language=${configLanguage}&fields=address_component,geometry`);
const facebookApi = $.getScript('https://connect.facebook.net/it_IT/sdk.js');


// Date inputs' custom behavior
function storageAvailable(type) {
  const storage = window[type];
  const x = '__storage_apply__';
  try {
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' ||
        // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage.length !== 0
    );
  }
}

function translate(resources, currLang, word) {
  if (resources[currLang] === undefined) return resources.it[word];
  if (currLang.includes('-')) {
    const currLanguage = currLang.substr(0, currLang.indexOf('-'));
    return resources[currLanguage][word];
  }
  return resources[currLang][word];
}

function applyTemplate(tmpl, currentLanguage) {
  return tmpl.replace(tmpl, word => translate(dict, currentLanguage, word));
}

// When DOM is ready..
$(() => {
  console.log('DOM Ready');
  $(document).foundation();

  // JQuery Cache
  const $CPDriver = $('#CPDriver');
  const $hiddenData = $('#hiddenData');
  const $clientDateTime = $('#clientDateTime');
  const $jobsBox = $('#jobsBox');
  const $educationBox = $('#educationBox');
  const $attachmentsBox = $('#attachmentsBox');
  const $classificationsBox = $('#classificationsBox');
  const $languageBox = $('#languageBox');
  const $addJobExperience = $('#addJobExperience');
  const $addEducation = $('#addEducation');
  const $addAttachment = $('#addAttachment');
  const $addLanguageSkill = $('#addLanguageSkill');


  now = moment(now);
  const stuffToSave = [
    'Applicant.Name',
    'Applicant.Surname',
    'Applicant.Gender',
    'Day',
    'Month',
    'Year',
    'Applicant.Email',
    'Applicant.Phone',
    'Location',
    'Applicant.Country',
    'Applicant.City',
    'Applicant.FiscalCode',
    'Applicant.PostalCode',
    'Applicant.PresentationLetter',
    'Applicant.LanguageSkills',
    'Jobs',
    'Education',
    'Applicant.Facebook',
    'Applicant.Linkedin',
    'Applicant.Website',
    'Applicant.Twitter',
  ];

  const validateConfig = {
    wrapper: 'div',
    errorElement: 'span',
    errorClass: 'alert',

    // Prevent the error messages' placement
    errorPlacement: ($error, $element) => {
      if ($element.attr('name').includes('Attachments')) {
        $error.addClass('callout alert');
        $element.parent().after($error);
      }
    },

    highlight: (input, errorClass, validClass) => {
      if ($(input).attr('type') === 'file') {
        $(input)
          .parent('label')
          .addClass(errorClass)
          .removeClass('neutro');
      } else {
        $(input)
          .addClass(errorClass)
          .removeClass(validClass)
          .parent('label')
          .addClass('is-invalid-label');
      }
    },

    unhighlight: (input, errorClass, validClass) => {
      if ($(input).attr('type') === 'file') {
        $(input)
          .parent('label')
          .addClass('neutro')
          .removeClass(errorClass);
      } else {
        $(input)
          .addClass(validClass)
          .removeClass(errorClass)
          .parent('label')
          .removeClass('is-invalid-label');
      }
    },
  };
  const passthroughData = JSON.parse(atob($hiddenData.val()));
  const serverDatetime = moment(passthroughData.serverDatetime);
  const delta = now.diff(serverDatetime);
  const { max: maxJobs = 3 } = config.jobExperiences;
  const { max: maxEducation = 3 } = config.education;
  const { max: maxAttachments = 3 } = config.attachments;
  const showSalaryField = config.jobExperiences.showSalaryField === true;
  const showBenefitsField = config.jobExperiences.showBenefitsField === true;
  const showReferencesField = config.jobExperiences.showReferencesField === true;
  const showNotesField = config.jobExperiences.showNotesField === true;
  const languageDropdownTemplate = templates.languageSkill.render({ languages });
  const years = range(serverDatetime.year(), serverDatetime.year() - 100);
  const months = range(1, 13);
  let attachmentsCounter = 0;
  let jobsCounter = 0;
  let educationCounter = 0;
  let isLocationValid = false;
  let autocomplete;


  function fillForm(values = []) {
    // se c'è stato un login con linkedin o con
    // jobonair evito il riempimento automatico perchè prevarrebbe
    if (document.body.contains(document.getElementById('login-hidden'))) {
      return;
    }
    values.forEach(({ name, value }) => {
      switch (name) {
        case 'Jobs': {
          $addJobExperience.trigger('click', { backup: JSON.parse(value) });
          break;
        }
        case 'Education': {
          $addEducation.trigger('click', { backup: JSON.parse(value) });
          break;
        }
        case 'Applicant.LanguageSkills': {
          const [lang, level] = value.split(';');
          $addLanguageSkill.trigger('click', { lang, level });
          break;
        }
        default: {
          $CPDriver[0].elements[name].value = value;
        }
      }
    });
  }

  console.info("Here's the server datetime:", serverDatetime);
  console.info("And here's the difference with this client:", delta);

  $.ajaxSetup({ cache: true });

  // Including Facebook API   appId: '128503837815912' x locahost
  facebookApi
    .done(() => {
      console.log('Fetched Facebook API');
      FB.init({
        appId: '231276064468342',
        autoLogAppEvents: true,
        status: true,
        xfbml: false,
        version: 'v3.0',
      });

      // altre permission per cui richiedere l'autorizzazione: user_link,user_location
      const permissions = 'public_profile,email,user_birthday';
      console.info('Using these permissions:', permissions);
      const fieldsMap = {
        first_name: 'name',
        last_name: 'surname',
        birthday: 'birthDate',
        email: 'email',
        gender: 'gender',
        link: 'facebook',
      };
      const fields = Object.keys(fieldsMap);

      $('.facebook').click(() => {
        console.log('Requested Facebook login');

        FB.login((response) => {
          if (response.authResponse) {
            console.log('Successfully logged the user into Facebook');
            console.info('Response from Facebook:', response);

            FB.api('/me', { fields: fields.join() }, (data) => {
              console.info('Data fetched from Facebook Graph API:', data);

              const values = [];
              fields.forEach((field) => {
                const name = fieldsMap[field];
                let value;
                if (field === 'birthday') {
                  if (data[field] !== undefined) {
                    const date = moment(data[field], 'MM/DD/YYYY');
                    values.push({ name: 'Day', value: date.format('D') });
                    values.push({ name: 'Month', value: date.format('M') });
                    values.push({ name: 'Year', value: date.format('YYYY') });
                  }
                } else {
                  value = data[field];
                  if (value !== undefined) {
                    values.push({ name, value });
                  }
                }
              });
              fillForm(values);
            });

            FB.logout(() => console.log('Succesfully logged the user out from Facebook.'));
          } else {
            console.log('User cancelled login or did not fully authorize.');
          }
        }, {
          scope: permissions,
          return_scopes: true,
        });
      });
    })
    .fail((...errors) => console.warn('Failed to fetch Facebook API:', errors));

  // Bias the autocomplete object to the user's geographical location,
  // as supplied by the browser's 'navigator.geolocation' object.
  // function geolocate() {
  //  if (navigator.geolocation) {
  //    navigator.geolocation.getCurrentPosition((position) => {
  //      const geolocation = {
  //        lat: position.coords.latitude,
  //        lng: position.coords.longitude,
  //      };
  //      const par = { center: geolocation, radius: position.coords.accuracy };
  //      const circle = new google.maps.Circle(par);
  //      autocomplete.setBounds(circle.getBounds());
  //    });
  //  }
  // }

  // Including Google API
  googleApi
    .done(() => {
      console.log('Fetched Google API');

      const locationFields = {
        country: $('input#country')[0],
        locality: $('input#city')[0],
        administrative_area_level_1: $('input#region')[0],
        administrative_area_level_2: $('input#state')[0],
        postal_code: $('input#postal-code')[0],
        route: $('input#address')[0],
      };
      const lookupInput = document.getElementById('location');
      autocomplete = new google.maps.places.Autocomplete(lookupInput, { types: ['geocode'] });// eslint-disable-line
      autocomplete.setFields(['address_component']);

      // Prevent accidental submit on enter
      $(lookupInput).keydown((event) => {
        if (event.keyCode === 13) { event.preventDefault(); }
      });

      const fields = ['country', 'locality', 'route', 'postal_code', 'administrative_area_level_1', 'administrative_area_level_2'];
      autocomplete.addListener('place_changed', () => {
        const placeResponse = autocomplete.getPlace();
        if (placeResponse !== undefined) {
          console.info('Google Autocomplete service response:', placeResponse);

          const placeDetails = placeResponse.address_components;
          if (placeDetails !== undefined) {
            console.info('Google Autocomplete service response:', placeDetails);
            isLocationValid = true;
            if (!placeDetails.find(e => e.types.includes('locality'))) {
              isLocationValid = false;
              $('#location').parent().find('#wrong-residence').fadeIn();
            } else {
              $('#location').parent().find('#wrong-residence').fadeOut();
            }
            fields.forEach((field) => {
              const value = placeDetails.find(e => e.types.includes(field));
              locationFields[field].value = value !== undefined ? value.short_name : '';
            });
            const address = $('#address').val();
            if (address !== undefined) {
              const sn = placeDetails.find(e => e.types.includes('street_number'));
              if (sn !== undefined) {
                $('#address').val(address.concat(' ', sn.short_name));
              }
            }
          }
        }
      });

      $('#location').on('input', () => {
        isLocationValid = false;
        fields.forEach((field) => {
          locationFields[field].value = '';
        });
      }).on('blur', () => {
        if (!isLocationValid) {
          lookupInput.value = '';
        }
      }).on('focus', () => {
        // geolocate();
      });
    })
    .fail((...errors) => console.warn('Failed to fetch Google API:', errors));

  // Init classifications
  console.info('Using these classifications:', classifications);
  classifications.forEach((cls) => {
    // Filtering options, only want those which have no parent
    const items = cls.items.filter(option => option.parentId === null);
    const { id: clsId, label, description } = cls;

    // Rendering with partial
    const $newClassificationComponent = $(templates.classification.render({
      clsId, label, description, items,
    }, { clsDropdown: templates.clsDropdown }));
    $newClassificationComponent.appendTo($classificationsBox);

    // Attaching handler to the 'add' button
    $newClassificationComponent.find('.addCls').click(() => {
      console.log('Adding new classification');

      const $dropdowns = $newClassificationComponent.children('select.classification');
      const $labelsBox = $newClassificationComponent.children('.labelsBox');

      // The empty dropdown is ignored
      if ($dropdowns.length > 0) {
        const options = $dropdowns.children('option:selected[value!=""]').toArray();

        // Generating value and label
        const text = options
          .map(opt => opt.innerText)
          .join(' > ');
        const { value } = options[options.length - 1];

        const values = $labelsBox
          .children('span.label')
          .toArray()
          .map(span => $(span).attr('value'));

        if (!values.includes(value)) {
          $labelsBox.append(templates.clsLabel.render({ text, value }));
        }
      }
    }).hide();
  });

  $('#name').on('blur', () => {
    if (changedName !== 0) {
      return;
    }
    const str = $('#name').val();
    const res = str.split(' ');
    let finalResult = '';
    for (let i = 0; i < res.length; i++) {
      if (res[i] === '') {
        continue;
      }
      res[i] = $.trim(res[i]);
      res[i] = res[i].toLowerCase().replace(/\b[a-z]/g, letter => letter.toUpperCase());
      finalResult += `${res[i]} `;
    }
    finalResult = finalResult.substring(0, finalResult.length - 1);
    $('#name').val(finalResult);
    changedName += 1;
  });

  $('#surname').on('blur', () => {
    if (changedSurname !== 0) {
      return;
    }
    const str = $('#surname').val();
    const res = str.split(' ');
    let finalResult = '';
    for (let i = 0; i < res.length; i++) {
      if (res[i] === '') {
        continue;
      }
      res[i] = $.trim(res[i]);
      res[i] = res[i].toLowerCase().replace(/\b[a-z]/g, letter => letter.toUpperCase());
      finalResult += `${res[i]} `;
    }
    finalResult = finalResult.substring(0, finalResult.length - 1);
    $('#surname').val(finalResult);
    changedSurname += 1;
  });

  // Photo Input custom behavior
  $('#Photo').change(({ target }) => {
    console.log('The Photo input has changed');
    const reader = new FileReader();
    reader.readAsDataURL(target.files[0]);
    reader.onload = (e) => {
      $('img.thumbnail').attr('src', e.target.result);
    };
  });

  $('#toggleJobs').change(() => {
    $jobsBox.fadeToggle();
    $addJobExperience.fadeToggle();
  });

  $(document).on('click', '.button-icon', ({ target }) => {
    console.log('Target item: ', target);
    const $container = $(target).closest('.container');
    $container.remove();
  });

  $addLanguageSkill.on('click', (_event, { lang, level } = {}) => {
    console.log('New language skill');
    const $newLanguageSkillsComponent = $(languageDropdownTemplate);

    if (lang !== undefined && level !== undefined) {
      console.info('Data supplied to $addLanguageSkill#click:', { lang, level });
      $newLanguageSkillsComponent.find('select.languages').val(lang);
      $newLanguageSkillsComponent.find('select.levels').val(level);
    }


    $newLanguageSkillsComponent.find('.deleteLanguage').click(() => {
      $newLanguageSkillsComponent.remove();
      console.log('Language skill removed');
    });

    $languageBox.append($newLanguageSkillsComponent);

    const nodes = document.querySelectorAll('.replace');
    nodes.forEach((node) => {
      const currentValue = node;
      configLanguage = document.getElementById('Config_Language').value;
      const tmpl = currentValue.textContent;
      const html = applyTemplate(tmpl, configLanguage);
      currentValue.textContent = '';
      currentValue.insertAdjacentHTML('afterbegin', html);
      currentValue.classList.remove('replace');
    });
  });

  $addJobExperience.on('click', (_event, { backup, shouldDelete = true } = {}) => {
    if (jobsCounter < maxJobs) {
      console.log('New job experience');
      jobsCounter += 1;
      console.log(config);
      const $newJobExperienceComponent = $(templates.jobExperience.render({
        jobsCounter,
        shouldDelete,
        showSalaryField,
        showBenefitsField,
        showReferencesField,
        showNotesField,
        months,
        years,
      }));
      $newJobExperienceComponent.appendTo($jobsBox);

      const $inputs = $newJobExperienceComponent.find('input[type!=hidden][type!=checkbox], select');
      const $endDropdowns = $inputs.filter('.EndMonth, .EndYear');

      $inputs.filter('.Contract').easyAutocomplete({
        data: careerLevels,
      });

      if (config.defaultCurrency !== undefined) {
        console.info('Using default currency: ', config.defaultCurrency);
        $inputs.filter('.Currency').val(config.defaultCurrency);
      }

      if (backup !== undefined && backup.length === $inputs.length) {
        console.info('Data supplied to $addJobExperience#click:', backup);
        backup.forEach((_value, index) => {
          $inputs[index].value = backup[index];
        });
      }


      const nodes = document.querySelectorAll('.replace');
      nodes.forEach((node) => {
        const currentValue = node;
        const tmpl = currentValue.textContent;
        const html = applyTemplate(tmpl, configLanguage);
        currentValue.textContent = '';
        currentValue.insertAdjacentHTML('afterbegin', html);
        currentValue.classList.remove('replace');
      });

      $newJobExperienceComponent.find('.isFinished').change((event) => {
        const disabled = $(event.currentTarget).is(':checked');
        $endDropdowns.prop('disabled', disabled);
      });

      $newJobExperienceComponent.find('.deleteJobExperience').click(() => {
        $newJobExperienceComponent.remove();
        jobsCounter -= 1;
        console.log('Job experience removed');
      });
    } else {
      // ToDo
    }
  });
  $addEducation.on('click', (_event, { backup, shouldDelete = true } = {}) => {
    if (educationCounter < maxEducation) {
      console.log('New education');
      educationCounter += 1;

      // Except the first one, each education must be deletable
      const $newEducationComponent = $(templates.education.render({
        shouldDelete,
        years,
        educationCounter,
      }));
      $newEducationComponent.appendTo($educationBox);
      const $inputs = $newEducationComponent.find('input[type!=hidden], select');

      googleApi.done(() => {
        // eslint-disable-next-line
        var educationAutocomplete = new google.maps.places.Autocomplete($inputs.filter('.Locality')[0]);
        educationAutocomplete.setFields(['address_component']);
      });

      if (backup !== undefined && backup.length === $inputs.length) {
        console.info('Data supplied to $addEducation#click:', backup);
        backup.forEach((_value, index) => {
          $inputs[index].value = backup[index];
        });
      }


      const nodes = document.querySelectorAll('.replace');
      nodes.forEach((node) => {
        const currentValue = node;
        const tmpl = currentValue.textContent;
        const html = applyTemplate(tmpl, configLanguage);
        currentValue.textContent = '';
        currentValue.insertAdjacentHTML('afterbegin', html);
        currentValue.classList.remove('replace');
      });

      $newEducationComponent.find('.deleteEducation').click(() => {
        $newEducationComponent.remove();
        educationCounter -= 1;
        console.log('Education removed');
      });
    } else {
      // ToDo
    }
  });

  $addAttachment.on('click', (_event, { shouldDelete = true } = {}) => {
    if (attachmentsCounter < maxAttachments) {
      const $newAttachmentComponent = $(templates.attachment.render({
        attachmentsCounter,
        shouldDelete,
      }));
      $attachmentsBox.append($newAttachmentComponent);
      attachmentsCounter += 1;

      const inputFile = $newAttachmentComponent.find('input:file');

      inputFile.rules('add', {
        required: !shouldDelete, // If it's deleatable, it should NOT be required
        maxsize: 5000000,
        minsize: 0,
        extension: 'pdf|doc|docx|odt|rtf',
      });

      inputFile.change(({ target }) => {
        console.log('An attachment input has changed');
        $newAttachmentComponent.find('.fileName').text(target.files[0].name);

        if (window.File && window.FileReader) {
          // Great success! All the File APIs are supported.
          const reader = new FileReader();
          reader.addEventListener('error', (e) => {
            console.error(`Error occurred reading file: ${e.target.error.message}`);
          });

          reader.addEventListener('load', () => {
            console.log('File read successfully');
          });
          reader.readAsDataURL(target.files[0]);
        }

        // reader.onload = () => {
        //  $newAttachmentComponent.find('.fileName').text(target.files[0].name);
        // };
      });


      const nodes = document.querySelectorAll('.replace');
      nodes.forEach((node) => {
        const currentValue = node;
        const tmpl = currentValue.textContent;
        const html = applyTemplate(tmpl, configLanguage);
        currentValue.textContent = '';
        currentValue.insertAdjacentHTML('afterbegin', html);
        currentValue.classList.remove('replace');
      });

      $newAttachmentComponent.find('.deleteAttachment').click(() => {
        $newAttachmentComponent.remove();
        attachmentsCounter -= 1;
        console.log('Attachment removed');
      });
    }
  });

  document.body.addEventListener('dragover', (event) => {
    event.preventDefault();
  });

  document.body.addEventListener('drop', (event) => {
    event.preventDefault();
    const $firstAttachmentInput = $attachmentsBox.find('input:file:first');
    const files = event.target.files || (event.dataTransfer && event.dataTransfer.files);

    $firstAttachmentInput[0].files = files;
    $('#Applicant_PresentationLetter').focus();

    $firstAttachmentInput
      .parent()
      .find('.fileName')
      .text(files[0].name);
  });

  // Everytime a classification dropdown change its value
  $(document).on('change', 'select.classification', ({ target }) => {
    const $target = $(target);
    const $addCls = $target.parent().find('.addCls');
    const idSelected = Number.parseInt($target.children(':selected').attr('cls-id'), 10);

    $target.nextAll('select').remove();

    if (!Number.isNaN(idSelected)) {
      const clsId = Number.parseInt($target.attr('cls-id'), 10);

      // Taking just the classification i need..
      const theCls = classifications.find(cls => cls.id === clsId);

      // .. and then extract the options linked to the selected value
      const items = theCls.items.filter(option => option.parentId === idSelected);

      // If there are any, just render them after the current dropdown
      if (items.length > 0) {
        const newClsDropdown = templates.clsDropdown.render({ clsId, items });
        $target.after(newClsDropdown);
      }
      $addCls.show();
    } else {
      $addCls.hide();
    }
  });


  // Client validation
  $CPDriver.validate({
    ...validateConfig,
    rules: {
      // 'Applicant.Name': 'alphabetical',
      // 'Applicant.Surname': 'alphabetical',
      'Applicant.FiscalCode': {
        minlength: 16,
        maxlength: 16,
      },
      'Applicant.Email': 'email',
    },
    invalidHandler: (_event, validator) => {
      if (validator.numberOfInvalids() === 1 && !$('#privacy-policy').is(':checked')) {
        // eslint-disable-next-line
        alert('E\' necessario accettare la condizioni sulla privacy prima di continuare.');
      }
    },
    submitHandler: (form, event) => {
      console.log('Submit handler');
      event.preventDefault();

      let clsError = false;
      if ($('#Config_ClassificationsRequired').val() === 'True') {
        console.log($('#Config_ClassificationsRequired').val());
        $('.classificationSelect').each((i, obj) => {
          console.log(obj);
          if (obj.selectedIndex === 0) {
            clsError = true;
          }
        });
      }

      if (!clsError) {
        $(form).find('button[type="submit"]').prop('disabled', true);

        let values;
        let value;

        if ($jobsBox.is(':hidden')) {
          $jobsBox.remove();
        }

        // Generating hidden input for each compiled job experience
        $('fieldset.jobExperience').each((_, je) => {
          value = $(je)
            .find('input[type!=hidden], select')
            .toArray()
            .map(input => input.value);

          $CPDriver.append(`<input type="hidden" name="Jobs" value='${JSON.stringify(value)}'/>`);
        });

        // Generating hidden input for each compiled education
        $('fieldset.education').each((_, ed) => {
          value = $(ed)
            .find('input[type!=hidden], select')
            .toArray()
            .map(input => input.value);

          $CPDriver.append(`<input type="hidden" name="Education" value='${JSON.stringify(value)}'/>`);
        });

        // Retrieve values from classifications' dropdowns
        $('fieldset.classification').each((_, cls) => {
          const $addCls = $(cls).find('.addCls');

          if ($addCls.is(':hidden')) { return; }

          $addCls.click();
          const $labelsBox = $(cls).find('.labelsBox:not(:empty)');

          values = $labelsBox
            .children('span.label')
            .toArray()
            .map(elem => $(elem).attr('value'));

          value = values.join(';');

          // The generated value will be binded with a Classifications strings' array
          $CPDriver.append(`<input type="hidden" name="Applicant.Classifications" value="${value}" />`);
        });

        $languageBox.children('div.row').each((_, skill) => {
          const lang = $(skill)
            .find('select.languages')
            .val();
          const level = $(skill)
            .find('select.levels')
            .val();

          $CPDriver.append(`<input type="hidden" name="Applicant.LanguageSkills" value="${lang};${level}" />`);
        });

        const serialized = $CPDriver
          .serializeArray()
          .filter(field => stuffToSave.includes(field.name));
        localStorage.form = JSON.stringify(serialized);

        switch ($('#saveData').val()) {
          // Save on JobOnAir
          case '1':
            break;
          // Save form data in localStorage
          case '2': {
            break;
          }
          // Don't save
          case '3':
            break;
          // Clear
          case '4': {
            if (storageAvailable('localStorage')) {
              localStorage.clear();
            } else {
              console.warn("Can't use localStorage, check your browser's settings.");
            }
            break;
          }

          default: {
            console.warn('Looks like an error occured in selecting your save data method. Please, try to fill the form again.');
          }
        }

        const submitTimestamp = moment();
        submitTimestamp.add(delta, 'ms');
        // passthroughData.clientDatetime = submitTimestamp.toDate();
        // $hiddenData.val(JSON.stringify(passthroughData));
        // $clientDateTime.val(submitTimestamp.toDate());
        $clientDateTime.val(submitTimestamp.format('YYYY-MM-DD HH:mm:ss'));

        if (sessionStorage.getItem('s') == null) sessionStorage.setItem('s', document.URL);
        $('#ApplyOldUrl').val(sessionStorage.getItem('s'));

        form.submit();
      } else {
        $(form).find('button[type="submit"]').prop('disabled', false);
        $('.classificationSelect')[0].focus();
        $('.classificationSelect').each((i, obj) => {
          if (obj.selectedIndex === 0) {
            $(obj).addClass('alert');
          }
        });
      }
    },
  });

  $('#formLater').validate({
    ...validateConfig,
    rules: {
      'Applicant.Name': {
        required: true,
        alphabetical: true,
      },
      'Applicant.Surname': {
        required: true,
        alphabetical: true,
      },
      'Applicant.Email': {
        required: true,
        email: true,
      },
      Day: {
        required: true,
      },
      Month: {
        required: true,
      },
      Year: {
        required: true,
      },
      PrivacyPolicy: 'required',
    },
  });

  // load applicant's attachment
  // if ($('#attachmentsBox').find('.attName')) {
  //  $('#addAttachment').click();
  //  $('#attachmentsBox').find('.fileName').innerText =
  // $('#attachmentsBox').find('.attName').innerText;
  //  $('#attachmentsBox').find('.fileName').addClass('applicantAttachment');
  // }

  // Form repopulation from localStorage
  if (storageAvailable('localStorage')) {
    if (localStorage.form !== undefined) {
      console.log('Form backup finded in localStorage');
      const backup = JSON.parse(localStorage.form);
      console.info('Backup:', backup);
      fillForm(backup);
      console.log('Form restored');
    }
  } else {
    console.warn("Can't use localStorage, check your browser's settings.");
  }


  $('#closeModal').click(() => {
    $('#modalLater').foundation('close');
  });


  // Add minimum number of job experience, education info and attachments.
  for (let i = 0; i < config.jobExperiences.min; i += 1) {
    $addJobExperience.trigger('click', { shouldDelete: false });
  }

  for (let i = 0; i < config.education.min; i += 1) {
    $addEducation.trigger('click', { shouldDelete: false });
  }

  for (let i = 0; i < config.attachments.min; i += 1) {
    $addAttachment.trigger('click', { shouldDelete: false });
  }

  const nodes = document.querySelectorAll('.replace');
  nodes.forEach((node) => {
    const currentValue = node;
    const tmpl = currentValue.textContent;
    const html = applyTemplate(tmpl, configLanguage);
    currentValue.textContent = '';
    currentValue.insertAdjacentHTML('afterbegin', html);
    currentValue.classList.remove('replace');
  });
});
